export default "__VITE_ASSET__BzzOvp_4__"